import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Container from '../ui/Container';
import SubsidiaryCard from './SubsidiaryCard';
import { subsidiariesData } from './subsidiariesData';

interface GroupSectionProps {
  name: string;
  logo: string;
  description: string;
  subsidiaries: string[];
}

export default function GroupSection({ name, logo, description, subsidiaries }: GroupSectionProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <section className="py-8">
      <Container>
        <motion.div
          layout
          className="bg-white rounded-lg shadow-md overflow-hidden"
        >
          <div 
            className="p-6 cursor-pointer hover:bg-gray-50 transition-colors"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            <div className="flex items-center gap-8">
              <img
                src={logo}
                alt={`${name} Logo`}
                className="w-48 h-auto object-contain"
              />
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-2">{name}</h2>
                <p className="text-gray-600">{description}</p>
              </div>
            </div>
          </div>

          <AnimatePresence>
            {isExpanded && (
              <motion.div
                initial={{ opacity: 0, height: 0 }}
                animate={{ 
                  opacity: 1, 
                  height: "auto",
                  transition: {
                    height: {
                      type: "spring",
                      stiffness: 500,
                      damping: 30,
                      duration: 0.3
                    }
                  }
                }}
                exit={{ 
                  opacity: 0,
                  height: 0,
                  transition: {
                    height: {
                      duration: 0.2
                    }
                  }
                }}
              >
                <div className="px-6 pb-6 space-y-4">
                  {subsidiaries.map((name) => {
                    const subsidiary = subsidiariesData.find(s => s.name === name);
                    return subsidiary && (
                      <SubsidiaryCard
                        key={name}
                        subsidiary={subsidiary}
                      />
                    );
                  })}
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </motion.div>
      </Container>
    </section>
  );
}